<template>
  <div class="text-center">
    <template v-if="institution && institution.internal_use_id == 'duoc.cl'">
      <div class="d-flex text-bold container-title-duoc">
        <div class="d-flex mr-auto ml-auto">
          <div class="d-flex flex-column text-left mr-5">
            <div>
              {{ $t("curricularMesh.curricularMeshView.curricularMesh") }}
              {{ $getVisibleNames("mesh.career", false, "Programa") }}
            </div>
            <div>
              {{
                $getVisibleNames(
                  "manual.egress_profile_code",
                  false,
                  "Código de Perfil de Egreso"
                )
              }}
            </div>
            <div>
              {{
                $getVisibleNames(
                  "manual.mesh.titulo_profesional",
                  false,
                  "Título Profesional"
                )
              }}
            </div>
            <div>{{ $t("curricularMesh.curricularMeshView.modality") }}</div>
            <div v-if="institution && institution.internal_use_id == 'duoc.cl'">
              {{ $t("curricularMesh.curricularMeshView.intermediateOutput") }}
            </div>
            <div v-if="institution && institution.internal_use_id == 'duoc.cl'">
              {{ $t("curricularMesh.curricularMeshView.continuity") }}
            </div>
          </div>
          <div class="d-flex flex-column">
            <div>:</div>
            <div>:</div>
            <div>:</div>
            <div>:</div>
            <div v-if="institution && institution.internal_use_id == 'duoc.cl'">
              :
            </div>
            <div v-if="institution && institution.internal_use_id == 'duoc.cl'">
              :
            </div>
          </div>
          <div class="d-flex flex-column ml-3 text-left">
            <div>
              <span v-if="career && career.name">
                {{ career.name }}
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="egressProfile && egressProfile.code">
                {{ egressProfile.code }}
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="egressProfile && egressProfile.professional_title">
                {{ egressProfile.professional_title }}
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span>
                {{ egressProfileModality() }}
              </span>
            </div>
            <div v-if="institution && institution.internal_use_id == 'duoc.cl'">
              <span
                v-if="egressProfile && egressProfile.intermediate_output_name"
              >
                {{ egressProfile.intermediate_output_name }}
              </span>
              <span v-else>-</span>
            </div>
            <div v-if="institution && institution.internal_use_id == 'duoc.cl'">
              <span v-if="egressProfile && egressProfile.continuity_name">
                {{ egressProfile.continuity_name }}
              </span>
              <span v-else>-</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <h4 v-else>
      {{ $t("curricularMesh.curricularMeshView.curricularMesh") }}
      {{
        career
          ? String($getVisibleNames("mesh.career", false, "Programa") + ": ") +
            career.name
          : ""
      }}
    </h4>
    <div class="d-flex">
      <GenericButtonDownload
        :class="`text-left mr-3 mb-2 ml-auto noprint`"
        :tooltip_text="$t('curricularMesh.curricularMeshView.curricularMesh')"
        :click_button="DownloadCurricularMeshXLS"
        :disabled_button="disabled_button_excel"
        :icon_excel="true"
      ></GenericButtonDownload>
    </div>
    <div v-if="egressProfile" class="table-container">
      <table
        class="table-container-curricular-mesh"
        :class="{
          'table-custom-width-1': semesterAmount.length >= 10,
          'table-custom-width-2': semesterAmount.length < 10,
        }"
        :style="{ minWidth: tableMinWidth }"
      >
        <thead>
          <tr v-if="egressProfileCycleSort.length > 0">
            <td></td>
            <template v-for="(cycle, index) in egressProfileCycleSort">
              <!-- Gap antes del ciclo -->
              <td
                v-if="getGapBeforeCycle(cycle, index) > 0"
                :key="`gap-${cycle.id}`"
                :colspan="getGapBeforeCycle(cycle, index)"
              ></td>
              <!-- Ciclo -->
              <td
                :key="cycle.id"
                :colspan="cycleColspan(cycle)"
                class="cycle-cell"
              >
                {{ $getVisibleNames("mesh.cycle", false, "Ciclo Formativo") }}
                {{ cycle.name }}
              </td>
            </template>
            <!-- Gap al final si existe -->
            <td
              v-if="getGapAfterLastCycle() > 0"
              :colspan="getGapAfterLastCycle()"
            ></td>
          </tr>
          <tr>
            <th style="width: 110px !important"></th>
            <template
              v-if="institution && institution.internal_use_id != 'duoc.cl'"
            >
              <template
                v-for="year in yearPerCycleSort.filter(
                  (x) =>
                    semesterAmount.includes(x.init_semester) ||
                    semesterAmount.includes(x.end_semester)
                )"
              >
                <th
                  class="semester-cell"
                  :key="'year' + year.order"
                  :colspan="yearColspan(year)"
                >
                  {{ year.order }}°
                  {{
                    $t("curricularMesh.curricularMeshView.year").toUpperCase()
                  }}
                </th>
              </template>
            </template>
          </tr>
          <tr>
            <th></th>
            <th
              v-for="index in semesterAmount"
              :key="index"
              class="semester-cell"
            >
              {{ index }}° {{ getLevelLabel().toUpperCase() }}
            </th>
          </tr>
        </thead>
        <template v-for="formation_area in formationAreasList">
          <FormationAreaRow
            v-if="hideFormationArea(formation_area.id)"
            :key="formation_area.id"
            :EgressProfile="egressProfile"
            :FormationArea="formation_area"
            :cycle_id="cycle_id"
            :allow_redirecting_matter="allow_redirecting_matter"
          ></FormationAreaRow>
        </template>
        <!-- <template>
          <CoursesWrapperRow
            :EgressProfile="egressProfile"
            :cycle_id="cycle_id"
          >
          </CoursesWrapperRow>
        </template> -->
        <tr
          v-if="institution && institution.internal_use_id != 'ipss.cl'"
          class="total"
          style="margin-top: 1em !important"
        >
          <td class="totalTitle">
            <div class>
              <b>{{
                $getVisibleNames(
                  "manual.credits",
                  true,
                  "Créditos SCT Totales"
                ).toUpperCase()
              }}</b>
            </div>
          </td>
          <td v-for="index in semesterAmount" :key="index">
            <div v-if="profileType">
              <span class="container-total">
                {{ totalSCT(index) }}
              </span>
            </div>
          </td>
        </tr>
        <tr
          v-if="$hasInstitutionalCredits(institution)"
          class="total"
          style="margin-top: 1em !important"
        >
          <td class="totalTitle">
            <div class>
              <b>{{
                $getVisibleNames(
                  "manual.institutional_credits",
                  true,
                  "Créditos Institucionales"
                ).toUpperCase()
              }}</b>
            </div>
          </td>
          <td v-for="index in semesterAmount" :key="index">
            <div v-if="profileType">
              <span class="container-total">
                {{ totalInstitutionalCredits(index) }}
              </span>
            </div>
          </td>
        </tr>
        <tr class="total">
          <template
            v-if="
              institution &&
              institution.internal_use_id != 'dionisioromerouniversity.com'
            "
          >
            <td class="totalTitle">
              <template>
                <b>
                  {{
                    $getVisibleNames(
                      "manual.total_pedagogical_hours",
                      true,
                      "Total de Horas Pedagógicas"
                    ).toUpperCase()
                  }}
                </b>
              </template>
            </td>
            <td v-for="index in semesterAmount" :key="index">
              <template>
                <span class="container-total">
                  {{ totalPedagogical(index) }}
                </span>
              </template>
            </td>
          </template>
          <template v-else>
            <td class="totalTitle">
              <template>
                <b>
                  {{
                    $getVisibleNames(
                      "manual.total_chronological_hours",
                      true,
                      "Total de Horas Cronológicas"
                    ).toUpperCase()
                  }}
                </b>
              </template>
            </td>
            <td v-for="index in semesterAmount" :key="index">
              <template>
                <span class="container-total">
                  {{ totalChronological(index) }}
                </span>
              </template>
            </td>
          </template>
        </tr>
      </table>
    </div>
    <!-- Tablas que se encuentran abajo de la malla curricular. -->
    <CurricularMeshOtherTables
      :egress_profile_id="egress_profile_id"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
    ></CurricularMeshOtherTables>
    <!-- Tabla resumen de las asignaturas para imprimir. -->
    <div>
      <SumaryTableOfMatters
        class="page-break"
        :egress_profile_id="egress_profile_id"
        :allows_crud="allows_crud"
        :cycle_id="cycle_id"
      ></SumaryTableOfMatters>
    </div>
    <b-modal
      :id="`new-certification-modal`"
      :hide-footer="true"
      :title="`${$t('reusable.common.create')} ${$getVisibleNames(
        'mesh.certification',
        false,
        'Certificación de Credenciales'
      )}`"
      size="lg"
    >
      <CertificationForm
        @created="$bvModal.hide('new-certification-modal')"
        :EgressProfile="egressProfile"
      ></CertificationForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  showLoadingAlert,
  downloadFileFromResponse,
} from "@/utils/utils";

export default {
  name: "CurricularMesh",
  components: {
    CertificationForm: () =>
      import(
        "@/components/mesh/CurricularResources/Certification/CertificationForm"
      ),
    FormationAreaRow: () => import("./FormationAreaRow"),
    // CoursesWrapperRow: () => import("./CoursesWrapperRow"),
    SumaryTableOfMatters: () => import("./SumaryTableOfMatters"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    CurricularMeshOtherTables: () => import("./CurricularMeshOtherTables"),
  },
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: false,
    },
    can_update: {
      type: Boolean,
      required: false,
    },
    can_delete: {
      type: Boolean,
      required: false,
    },
    cycle_id: {
      type: Number,
    },
    allow_redirecting_matter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabled_button_excel: false,
    };
  },
  computed: {
    ...mapGetters({
      cycles: names.CYCLES,
      formationAreas: names.FORMATION_AREAS,
      profile_cycles: names.PROFILE_CYCLES,
      profile_types: names.PROFILE_TYPES,
      regimes: names.REGIMES,
      matters: names.MATTERS,
      egressProfiles: names.EGRESS_PROFILES,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      institution: "getInstitution",
      certifications: names.CERTIFICATIONS,
      careers: names.CAREERS,
      time_allocations: names.TIME_ALLOCATIONS,
      courses_wrapper: names.COURSES_WRAPPER,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
      modalities_egress_profiles: names.MODALITIES_EGRESS_PROFILE,
    }),
    egressProfile() {
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    egressProfilesMatters() {
      return this.egress_profiles_matters.filter(
        (x) => x.egress_profile == this.egress_profile_id
      );
    },
    isAnual() {
      const months_amount_egress_profile = this.regimes.find(
        (x) => x.id == this.egressProfile.regime
      );
      if (months_amount_egress_profile) {
        if (months_amount_egress_profile.months_amount == 6)
          return this.regimes.find(
            (x) =>
              x.name.includes("Anual") || parseInt(x.months_amount) / 6 == 2
          );
        else if (months_amount_egress_profile.months_amount == 3)
          return this.regimes.find(
            (x) =>
              x.name.includes("Semestral") || parseInt(x.months_amount) / 3 == 2
          );
        else if (months_amount_egress_profile.months_amount == 2)
          return this.regimes.find(
            (x) =>
              x.name.includes("Trimestral") || parseInt(x.months_amount) == 3
          );
      }
      return this.regimes.find(
        (x) => x.name.includes("Anual") || parseInt(x.months_amount) / 6 == 2
      );
    },
    profileType() {
      if (!this.egressProfile) return null;
      return this.profile_types.find(
        (x) => x.id == this.egressProfile.egress_profile_type
      );
    },
    formationAreasList() {
      let list = [...this.formationAreas];
      if (
        list.length > 0 &&
        this.egressProfilesMatters.some((x) => x.formation_area != null)
      )
        list.push({
          id: 0,
          name: String(
            "Sin " +
              this.$getVisibleNames(
                "mesh.formationarea",
                false,
                "Área De Formación"
              )
          ),
          description: String(
            "Sin " +
              this.$getVisibleNames(
                "mesh.formationarea",
                false,
                "Área De Formación"
              )
          ),
          order: 0,
        });
      else
        list.push({
          id: 0,
          name: "",
          description: "",
          order: 0,
        });
      return list;
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    // filteredCycles() {
    //   if (!this.cycle_id) return this.cycles;
    //   return this.cycles.filter((x) => x.id == this.cycle_id);
    // },
    cycles_avaibles() {
      // Ordena el arreglo basado en el init_semester
      const profile_cycle = [
        ...this.profile_cycles.filter(
          (x) => x.egress_profile == this.egress_profile_id
        ),
      ].sort((a, b) => a.init_semester - b.init_semester);
      const result = profile_cycle.reduce((acc, curr) => {
        // Si el arreglo está vacío, simplemente agrega el primer elemento
        if (acc.length === 0) {
          acc.push(curr);
          return acc;
        }
        // Si el init_semester del elemento actual es mayor al end_semester del último elemento agregado al arreglo,
        // significa que no hay superposición, y por lo tanto, puedes agregar el elemento actual.
        if (curr.init_semester > acc[acc.length - 1].end_semester) {
          acc.push(curr);
        }
        return acc;
      }, []);
      return result.map((x) => x.id);
    },
    egressProfileCycleId() {
      if (!this.egress_profile_id) return [];
      let list = [];
      if (this.institution && this.institution.internal_use_id == "umb.edu.co")
        this.profile_cycles.forEach((x) => {
          if (
            x.egress_profile == this.egress_profile_id &&
            this.cycles_avaibles.includes(x.id)
          )
            list.push(x.cycle);
        });
      else
        this.profile_cycles.forEach((x) => {
          if (x.egress_profile == this.egress_profile_id) list.push(x.cycle);
        });
      return list;
    },
    egressProfileCycleSort() {
      if (!this.egressProfile) return [];
      let cycles = this.cycles.filter((x) =>
        this.egressProfileCycleId.includes(x.id)
      );
      cycles.forEach((x) => {
        let cycle_list = this.profile_cycles.find(
          (profile_cycle) =>
            profile_cycle.cycle == x.id &&
            profile_cycle.egress_profile == this.egress_profile_id
        );
        if (cycle_list) {
          x.init_semester = cycle_list.init_semester;
          x.end_semester = cycle_list.end_semester;
          x.order = cycle_list.order;
        }
      });
      if (this.cycle_id) return cycles.filter((x) => x.id == this.cycle_id);
      return cycles.sort(function (a, b) {
        if (a.init_semester < b.init_semester) return -1;
        if (a.init_semester > b.init_semester) return 1;
        if (a.end_semester < b.end_semester) return -1;
        if (a.end_semester > b.end_semester) return 1;
        return 0;
      });
    },
    yearPerCycleSort() {
      if (!this.egressProfile) return [];
      const regimen = this.regimes.find(
        (x) => x.id == this.egressProfile.regime
      );
      let year_array = [];
      let year_order = 1;
      if (regimen) {
        for (let index = 1; index <= this.maxSemesterAmount; index++) {
          if (
            !year_array.find(
              (x) => index >= x.init_semester && index <= x.end_semester
            )
          ) {
            year_array.push({
              order: year_order,
              init_semester: index,
              end_semester:
                index + regimen.amount_per_year - 1 > this.maxSemesterAmount
                  ? this.maxSemesterAmount
                  : index + regimen.amount_per_year - 1,
            });
            year_order++;
          }
        }
        return year_array;
      }
      return [];
    },
    // semesterAmount() {
    //   let min = 14;
    //   let max = 0;
    //   this.filteredCycles.forEach((cycle) => {
    //     if (cycle.init_semester < min) min = cycle.init_semester;
    //     if (cycle.end_semester > max) max = cycle.end_semester;
    //   });
    //   if (this.egressProfile && max > this.egressProfile.semester_amount) {
    //     max = this.egressProfile.semester_amount;
    //   }
    //   let list = [];
    //   for (let index = min; index <= max; index++) {
    //     list.push(index);
    //   }
    //   return list;
    // },
    maxSemesterAmount() {
      let min = 14;
      let max = 0;
      if (!this.egressProfile) return 0;
      if (this.egressProfileCycleId.length == 0) {
        min = 1;
        max = this.egressProfile.semester_amount;
      } else {
        this.profile_cycles.forEach((cycle) => {
          if (
            cycle.init_semester < min &&
            cycle.egress_profile == this.egressProfile.id
          )
            min = cycle.init_semester;
          if (
            cycle.end_semester > max &&
            cycle.egress_profile == this.egressProfile.id
          )
            max = cycle.end_semester;
        });
      }
      if (max > this.egressProfile.semester_amount) {
        max = this.egressProfile.semester_amount;
      }
      return max;
    },
    // Ancho mínimo de la tabla para que cada columna de semestre quepa una
    // MatterCard completa (min-width 160px + celda). Con table-layout: fixed
    // y width 100%, las columnas se encogen y las tarjetas se solapan.
    tableMinWidth() {
      return `${110 + this.semesterAmount.length * 175}px`;
    },
    semesterAmount() {
      let min = 14;
      let max = 0;
      if (this.egressProfileCycleId.length == 0) {
        min = 1;
        max = this.egressProfile.semester_amount;
      } else {
        if (!this.cycle_id) {
          this.profile_cycles.forEach((cycle) => {
            if (
              cycle.init_semester < min &&
              cycle.egress_profile == this.egressProfile.id
            )
              min = cycle.init_semester;
            if (
              cycle.end_semester > max &&
              cycle.egress_profile == this.egressProfile.id
            )
              max = cycle.end_semester;
          });
        } else {
          this.profile_cycles.forEach((cycle) => {
            if (
              this.cycle_id == cycle.cycle &&
              cycle.init_semester < min &&
              cycle.egress_profile == this.egressProfile.id
            )
              min = cycle.init_semester;
            if (
              this.cycle_id == cycle.cycle &&
              cycle.end_semester > max &&
              cycle.egress_profile == this.egressProfile.id
            )
              max = cycle.end_semester;
          });
        }
      }
      if (max > this.egressProfile.semester_amount) {
        max = this.egressProfile.semester_amount;
      }
      let list = [];
      for (let index = min; index <= max; index++) {
        list.push(index);
      }
      return list;
    },
    coursesWrapperList() {
      return this.courses_wrapper
        .filter((x) => x.egress_profile == this.egress_profile_id)
        .sort(function (a, b) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          if (a.init_level < b.init_level) return -1;
          if (a.init_level > b.init_level) return 1;
          if (a.end_level < b.end_level) return -1;
          if (a.end_level > b.end_level) return 1;
          return 0;
        });
    },
    wrapperMatterIds() {
      let list = [];
      this.coursesWrapperList.forEach((x) => {
        list = list.concat(x.egress_profile_matters);
      });
      return [...new Set(list)];
    },
    matterList() {
      return this.egress_profiles_matters.filter(
        (x) =>
          x.egress_profile == this.egress_profile_id &&
          !this.wrapperMatterIds.includes(x.id)
      );
    },
  },
  methods: {
    getLevelLabel() {
      if (!this.egressProfile)
        return this.$t("curricularMesh.curricularMeshView.level");
      const regime = this.regimes.find(
        (x) => x.id == this.egressProfile.regime
      );
      if (!regime) return this.$t("curricularMesh.curricularMeshView.level");

      if (regime && regime.alt_name != "") return regime.alt_name;

      if (regime.months_amount == 6) {
        return this.$t("curricularMesh.curricularMeshView.semester");
      } else if (regime.months_amount == 3) {
        return this.$t("curricularMesh.curricularMeshView.trimester");
      } else if (regime.months_amount == 2) {
        return this.$t("curricularMesh.curricularMeshView.bimester");
      }
      return this.$t("curricularMesh.curricularMeshView.level");
    },
    cycleColspan(cycle) {
      let init_semester = cycle.init_semester;
      this.egressProfileCycleSort.forEach((x) => {
        if (
          cycle.init_semester <= x.end_semester &&
          cycle.end_semester > x.end_semester
        )
          init_semester = x.end_semester + 1;
      });
      return cycle.end_semester - init_semester + 1;
    },
    getGapBeforeCycle(cycle, index) {
      if (index === 0) {
        // Primer ciclo: gap desde el inicio hasta el ciclo
        const minSemester = this.semesterAmount[0] || 1;
        return cycle.init_semester - minSemester;
      } else {
        // Ciclos siguientes: gap desde el final del anterior hasta este
        const previousCycle = this.egressProfileCycleSort[index - 1];
        const previousEnd = previousCycle.end_semester;
        return cycle.init_semester - previousEnd - 1;
      }
    },
    getGapAfterLastCycle() {
      if (this.egressProfileCycleSort.length === 0) return 0;
      const lastCycle = this.egressProfileCycleSort[this.egressProfileCycleSort.length - 1];
      const maxSemester = this.semesterAmount[this.semesterAmount.length - 1];
      return maxSemester - lastCycle.end_semester;
    },
    yearColspan(year) {
      return this.semesterAmount.filter(
        (x) => year.init_semester <= x && year.end_semester >= x
      ).length;
    },
    hideFormationArea(formation_area_id) {
      if (formation_area_id != 0) {
        const egress_profile_matters = this.matterList.filter(
          (matter) => matter.formation_area == formation_area_id
        );
        const courses_wrappers = this.coursesWrapperList.filter(
          (course) => course.formation_area == formation_area_id
        );
        if (egress_profile_matters.length > 0 || courses_wrappers.length > 0)
          return true;
        return false;
      } else {
        const egress_profile_matters = this.matterList.filter(
          (matter) => matter.formation_area == null
        );
        const courses_wrappers = this.coursesWrapperList.filter(
          (course) => course.formation_area == null
        );
        if (egress_profile_matters.length > 0 || courses_wrappers.length > 0)
          return true;
        return false;
      }
    },
    totalChronological(plan_level) {
      let hours = 0;
      const chronological_hours_ids = this.time_allocations
        .filter((x) => x.uses_module_minutes == false)
        .map((x) => x.id);
      this.matterList.forEach((matter) => {
        let matter_hours = [];
        if (matter.use_matter_values) {
          matter_hours = this.matter_time_allocations.filter(
            (x) =>
              x.matter == matter.matter &&
              chronological_hours_ids.includes(x.time_allocation) &&
              x.counts_towards_credits == true
          );
        } else {
          matter_hours = this.ep_matter_time_allocations.filter(
            (x) =>
              x.egress_profile_matter == matter.id &&
              chronological_hours_ids.includes(x.time_allocation) &&
              x.counts_towards_credits == true
          );
        }
        matter_hours.forEach((hour) => {
          let current_hours = hour.hours;
          if (
            this.institution &&
            parseInt(this.institution.hour_decimal_places) === 0
          )
            current_hours = Math.round(current_hours);
          if (
            matter.plan_level == plan_level &&
            this.isAnual &&
            matter.regime == this.isAnual.id
          )
            hours += parseFloat(current_hours) / 2;
          else if (matter.plan_level == plan_level)
            hours += parseFloat(current_hours);
          if (
            this.isAnual &&
            matter.regime == this.isAnual.id &&
            plan_level % 2 == 0 &&
            matter.plan_level == plan_level - 1
          )
            hours += parseFloat(current_hours) / 2;
        });
      });
      if (
        this.institution &&
        parseInt(this.institution.hour_decimal_places) === 0
      ) {
        return parseFloat(Math.round(hours));
      } else
        return parseFloat(
          hours.toFixed(
            this.institution &&
              parseInt(this.institution.hour_decimal_places) > 0
              ? parseInt(this.institution.hour_decimal_places)
              : 2
          )
        );
    },
    totalPedagogical(plan_level) {
      if (!this.profileType) return 0;
      let hours = 0;
      const pedagogical_hours_ids = this.time_allocations
        .filter((x) => x.uses_module_minutes == true)
        .map((x) => x.id);
      this.matterList.forEach((matter) => {
        let matter_hours = [];
        if (matter.use_matter_values) {
          matter_hours = this.matter_time_allocations.filter(
            (x) =>
              x.matter == matter.matter &&
              pedagogical_hours_ids.includes(x.time_allocation) &&
              x.counts_towards_credits == true
          );
        } else {
          matter_hours = this.ep_matter_time_allocations.filter(
            (x) =>
              x.egress_profile_matter == matter.id &&
              pedagogical_hours_ids.includes(x.time_allocation) &&
              x.counts_towards_credits == true
          );
        }
        matter_hours.forEach((hour) => {
          let current_hours = hour.hours;
          if (
            this.institution &&
            parseInt(this.institution.hour_decimal_places) === 0
          )
            current_hours = Math.round(current_hours);
          if (
            matter.plan_level == plan_level &&
            this.isAnual &&
            matter.regime == this.isAnual.id
          )
            hours += parseFloat(current_hours) / 2;
          else if (matter.plan_level == plan_level)
            hours += parseFloat(current_hours);
          if (
            this.isAnual &&
            matter.regime == this.isAnual.id &&
            plan_level % 2 == 0 &&
            matter.plan_level == plan_level - 1
          )
            hours += parseFloat(current_hours) / 2;
        });
      });
      if (
        this.institution &&
        parseInt(this.institution.hour_decimal_places) === 0
      ) {
        return parseFloat(Math.round(hours));
      } else
        return parseFloat(
          hours.toFixed(
            this.institution &&
              parseInt(this.institution.hour_decimal_places) > 0
              ? parseInt(this.institution.hour_decimal_places)
              : 2
          )
        );
    },
    totalSCT(plan_level) {
      let totalSCT = 0;
      this.matterList.forEach((matter) => {
        if (matter.use_matter_values) {
          const old_matter = this.matters.find((x) => x.id == matter.matter);
          if (old_matter) {
            if (
              this.isAnual &&
              matter.regime == this.isAnual.id &&
              plan_level % 2 == 0 &&
              matter.plan_level == plan_level - 1
            ) {
              totalSCT += parseFloat(old_matter.credits) / 2;
            }
            if (
              matter.plan_level == plan_level &&
              this.isAnual &&
              matter.regime == this.isAnual.id
            )
              totalSCT += parseFloat(old_matter.credits) / 2;
            else if (matter.plan_level == plan_level) {
              totalSCT += parseFloat(old_matter.credits);
            }
          }
        } else {
          if (
            this.isAnual &&
            matter.regime == this.isAnual.id &&
            plan_level % 2 == 0 &&
            matter.plan_level == plan_level - 1
          ) {
            totalSCT += parseFloat(matter.credits) / 2;
          }
          if (
            matter.plan_level == plan_level &&
            this.isAnual &&
            matter.regime == this.isAnual.id
          )
            totalSCT += parseFloat(matter.credits) / 2;
          else if (matter.plan_level == plan_level) {
            totalSCT += parseFloat(matter.credits);
          }
        }
      });
      // if (plan_level == this.maxSemesterAmount) {
      //   const credits = this.coursesWrapperList
      //     .map((x) => x.credits)
      //     .reduce((a, b) => a + b, 0);
      //   if (credits > 0) totalSCT += credits;
      // }
      return Math.round(totalSCT);
    },
    totalInstitutionalCredits(plan_level) {
      let totalInstitutionalCredits = 0;
      this.matterList.forEach((matter) => {
        if (matter.use_matter_values) {
          const old_matter = this.matters.find((x) => x.id == matter.matter);
          if (old_matter) {
            if (
              this.isAnual &&
              matter.regime == this.isAnual.id &&
              plan_level % 2 == 0 &&
              matter.plan_level == plan_level - 1
            ) {
              totalInstitutionalCredits +=
                parseFloat(old_matter.institutional_credits) / 2;
            }
            if (
              matter.plan_level == plan_level &&
              this.isAnual &&
              matter.regime == this.isAnual.id
            )
              totalInstitutionalCredits +=
                parseFloat(old_matter.institutional_credits) / 2;
            else if (matter.plan_level == plan_level) {
              totalInstitutionalCredits += parseFloat(
                old_matter.institutional_credits
              );
            }
          }
        } else {
          if (
            this.isAnual &&
            matter.regime == this.isAnual.id &&
            plan_level % 2 == 0 &&
            matter.plan_level == plan_level - 1
          ) {
            totalInstitutionalCredits +=
              parseFloat(matter.institutional_credits) / 2;
          }
          if (
            matter.plan_level == plan_level &&
            this.isAnual &&
            matter.regime == this.isAnual.id
          )
            totalInstitutionalCredits +=
              parseFloat(matter.institutional_credits) / 2;
          else if (matter.plan_level == plan_level) {
            totalInstitutionalCredits += parseFloat(
              matter.institutional_credits
            );
          }
        }
      });
      return Math.round(totalInstitutionalCredits);
    },
    DownloadCurricularMeshXLS() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(
          `/mesh/excel_report_curricular_mesh/`,
          {
            egress_profile_id: this.egress_profile_id,
            egress_profile_matter_ids: this.matterList.map((x) => x.id),
            course_wrapper_ids: this.coursesWrapperList.map((x) => x.id),
            formation_area_ids: this.formationAreas.map((x) => x.id),
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            () => {
              this.disabled_button_excel = false;
            },
            () => {
              this.disabled_button_excel = false;
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t("reusable.common.downloadError"),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    egressProfileModality() {
      if (!this.egressProfile) return "N/A";
      const modality = this.modalities_egress_profiles.find(
        (x) => x.id == this.egressProfile.modality
      );
      if (modality) return modality.name;
      return "N/A";
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_MODALITIES_EGRESS_PROFILE);
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
    this.$store.dispatch(names.FETCH_FORMATION_AREAS);
    this.$store.dispatch(names.FETCH_REGIMES);
    this.$store.dispatch(names.FETCH_PROFILE_TYPES);
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_COMPETENCES, this.egress_profile_id);
    this.$store.dispatch(names.FETCH_COURSES_WRAPPER, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES_MENTION, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_MODALITIES);
    // Antes pedía TODAS las certificaciones de la institución y filtraba acá
    // por perfil de egreso (ver filteredCertifications en
    // CurricularMeshOtherTables.vue); ahora filtra del lado del backend.
    this.$store.dispatch(names.FETCH_CERTIFICATIONS, {
      egress_profile_id: this.egress_profile_id,
    });
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.page-break {
  page-break-before: always;
  page-break-after: auto;
  page-break-inside: avoid;
}
.text-bold {
  font-weight: bold;
}
/* La propiedad para ancho de celdas de la malla curricular "table-layout: fixed;"
 bloquea el width de los elementos hijos (FormationAreaRow y MatterCard) 
 tener en consideracion las clases "table, table-custom-width-1 y table-custom-width-2*/
.table-container-curricular-mesh {
  width: 100%;
  table-layout: fixed;
}
.table-custom-width-1 {
  width: auto;
  min-width: 100%;
}
.table-custom-width-2 {
  width: 100%;
}
/* Header de Ciclo Formativo (agrupador superior): tono más fuerte del estándar */
.cycle-cell {
  background-color: var(--kl-color-accent-medium);
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
}
.cycle-cell.empty::before {
  color: var(--kl-color-accent-medium);
  content: " #";
}
/* Header de Año / Semestre (sub-header): azul de acento del estándar */
.semester-cell {
  font-size: var(--kl-fs-caption);
  background-color: var(--kl-color-accent);
  border: 1px solid white;
  color: var(--kl-text-on-primary);
  font-weight: var(--kl-fw-bold);
}
#hintCard {
  position: absolute;
  z-index: 9;
  background-color: #f1f1f1;
  border: 1px solid #d3d3d3;
  box-sizing: border-box;
  text-align: center;
  width: 280px;
  height: 142px auto;
  top: 20%;
  left: 70%;
}
#hintCardHeader {
  padding: 5px;
  cursor: move;
  z-index: 10;
  background-color: #7c7c7c;
  color: #fff;
  font-size: small;
  font-weight: bold;
  margin-bottom: 0.7em;
}
.hint {
  color: white;
  background-color: #f06643;
  height: 16px;
  width: 32px;
  font-size: 10px;
  font-weight: bold;
  border: 1px solid #7c7c7c;
  margin-bottom: 0.3em;
  margin-left: 1em;
  padding-left: 8px;
  padding-bottom: 1px;
  display: flex;
}
.hintCaption {
  font-size: 11px;
  color: #2e2e2e;
  white-space: nowrap;
  top: 1px;
  padding-left: 16px;
}
#button {
  width: 23px;
  height: 20px;
  float: right;
  cursor: pointer;
  color: white;
}
/* Celda-título de las filas de totales: header lateral del estándar */
.totalTitle {
  background-color: var(--kl-color-accent-medium);
  border: 2px solid white;
  color: var(--kl-text-on-primary);
  font-size: var(--kl-fs-caption);
  font-weight: var(--kl-fw-bold);
  word-wrap: break-word;
  padding-left: 8px;
  text-align: left;
}
.total {
  font-size: var(--kl-fs-body);
}
.total td {
  padding: 10px 5px;
  border: 1px solid #d3d3d3;
}
.total:nth-of-type(even) {
  background-color: var(--kl-table-row-alt-bg);
}
.table-container {
  overflow: scroll;
  height: 80%;
}
.table.b-table >>> thead th {
  max-width: 100px !important;
}

@media print {
  .table-container {
    overflow: hidden;
  }
  table {
    width: 100%;
    table-layout: auto;
  }
  .table-container-curricular-mesh {
    table-layout: auto;
    /* Anula el min-width inline (tableMinWidth) para que quepa en la hoja */
    min-width: 0 !important;
  }
  .container-title-duoc {
    font-size: 18px;
    margin-bottom: 1em;
  }
  .semester-cell,
  .totalTitle {
    font-size: 16px !important;
  }
  .container-total {
    font-size: 14px !important;
  }
}
</style>